import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CODIGO_CENTRUS, MODO_PERSPECTIVA_ITENS_MENU_USUARIO } from '../../../../app.constants';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { StorafeUtil } from '../../util/storasge.util';



@Component({
  selector: 'app-botao-flutuante-voltar',
  templateUrl: './botao-flutuante-voltar.component.html',
  styleUrls: ['./botao-flutuante-voltar.component.css']
})
export class BotaoFlutuanteVoltarComponent implements OnInit {

  @Input() param: string;

  mostrarBotao = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<string>,
    private authInterceptor: AuthInterceptor,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.mostrarBotao = (this.authInterceptor.getJwtCdCentrus()) ? true : false;
  }


  backPaeg() {
    this.router.navigate([this.param], { replaceUrl: true });
    const modoConsultadoUusario = StorafeUtil.recuperarSessionStorage(MODO_PERSPECTIVA_ITENS_MENU_USUARIO);
    if (!modoConsultadoUusario) { StorafeUtil.limparSessionStorage(CODIGO_CENTRUS) };
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/layout/botao-flutuante-voltar/botao-flutuante-voltar.component.ts